import React from "react";
import ReactDOM from 'react-dom';
import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

class Linechart extends React.Component{
    constructor(props) {
        super(props)
        //console.log(this.props)
    }
    
    render(){
    var options = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: this.props.obj.chartname,
          },
        },
        scales: {
          x: {
            type: 'time',
            time: {
              // Luxon format string
                tooltipFormat: 'Date',
                unit: 'day',
                displayFormats: {
                   'day': 'MMM dd'
                }
            },
            title: {
              display: true,
              text: 'Date'
            }
          },
          y: {
            title: {
              display: true,
              text: 'value'
            }
          }
        },
        elements: {
          point:{
              radius: 0
          }
        }
      };
      
      let datasets = this.props.obj.datasets
      
      var labels = []
      var chartDatasets = []
      let period = Math.ceil((new Date(this.props.obj.endDate)-new Date(this.props.obj.startDate))/(1000 * 60 * 60 * 24))
      let step = this.props.obj.step ? this.props.obj.step : 1
      let count = period / step
      for(var j=0; j<datasets.length; j++){      
        var values = []
        //console.log('data:')
        //console.log(datasets[j]['data'])
        for(var i=0; i<count; i++){
          var date = new Date(new Date(this.props.obj.startDate).getTime() + ((i+1)*step*24*60*60*1000))
          if(!!this.props.obj.cumulativePlot){
            var prev_date = new Date(this.props.obj.startDate)
          }else{
            var prev_date = new Date(new Date(this.props.obj.startDate).getTime() + (i*step*24*60*60*1000))
          }
          
          labels.push(new Date(new Date(this.props.obj.startDate).getTime() + (i*step*24*60*60*1000)))
          var filteredArr = datasets[j]['data'].filter(function(v){
              return prev_date < new Date(v['date']) && new Date(v['date']) <= date;
            })
          //console.log(filteredArr)
          if( !this.props.obj.plotKey){
            var val = filteredArr.length
            values.push(val)
          }else{
            var key = this.props.obj.plotKey
            //console.log(key)
            var val = filteredArr.reduce(function(sum,v){
              return sum + v[key]
            },0)
            //console.log(val)
            values.push(val)
          }
        }
       
        chartDatasets.push({
          label: this.props.obj.datasets[j]['label'],
          data: values,
          borderColor: datasets[j]['borderColor'],
          backgroundColor: datasets[j]['backgroundColor']
        })
      }
      
      var data = {
        labels,
        datasets: chartDatasets
      }
      
    return <div><Line options={options} data={data} /></div>;
    }
}

export default Linechart